<template>
    <div>
        <el-menu default-active="1" class="el-menu-group" mode="horizontal" @select="handleSelect" >
            <el-menu-item index="1">首页轮播</el-menu-item>
            <el-menu-item index="5">优秀员工</el-menu-item>
            <el-menu-item index="2">合作伙伴</el-menu-item>
            <el-menu-item index="3">常见问题</el-menu-item>
            <el-menu-item index="4">系统信息</el-menu-item>
        </el-menu>
        <div style='margin-top:30px'></div>
        <div class="line"></div>
        <v-content1 v-if="itemVal==1"></v-content1>
        <v-content5 v-if="itemVal==5"></v-content5>
        <v-content2 v-if="itemVal==2"></v-content2>
        <v-content3 v-if="itemVal==3"></v-content3>
        <v-content4 v-if="itemVal==4"></v-content4>
    </div>

</template>

<script>
import $ from 'jquery';
import vContent1 from './login/LoginBanner.vue';
import vContent2 from './login/LoginPartner.vue';
import vContent3 from './login/LoginNews.vue';
import vContent4 from './login/Station.vue';
import vContent5 from './login/LoginBetterUser.vue';
export default {

    data() {
        return {  
           itemVal:'1', 
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        
    },
    components: { 
        vContent1,
        vContent2,
        vContent3,
        vContent4,
        vContent5,
    },

    methods: {
        handleSelect(key, keyPath) {
            this.itemVal = key;
        },
    }
};
</script>

<style scoped> 
</style>
